export default __webpack_public_path__ + "static/DSC_0039-f845bca9e7313e789cf783e5e7abc7dc.jpg";